export default {
  'collectPoint.title': 'Collect Points',
  'collectPoint.success': 'Points collected successfully',
  'collectPoint.obtained': 'Obtained',
  'collectPoint.point': 'Points',
  'collectPoint.enter_amount': 'Please enter the transaction amount',
  'collectPoint.enter_point': 'Please enter the number of points',
  'collectPoint.next_step': 'Next',
  'collectPoint.warning.NOT_REACH_THRESHOLD':
    'Did not reach the point collection threshold, only the transaction record was added',
  'collectPoint.error.LOYALTY_CARD_NOT_ENABLED': 'Point collection activity is not enabled',
  'collectPoint.error.LOYALTY_CARD_NOT_FOUND': 'Point collection activity information error',
  'collectPoint.error.SHOP_NOT_FOUND': 'Store information error',
  'collectPoint.error.FLEXIBLE_DEDUCTION_NOT_ENABLED':
    'Point deduction is not allowed for this activity',
  'collectPoint.error.SEND_RULE_NOT_FLEXIBLE_SEND': 'Send information error',
  'collectPoint.error.NOT_ENOUGH_POINT_FOR_DEDUCT': 'Not enough points for deduction',
  'collectPoint.error.PARTIAL_SEND_POINT_FAILED': 'Failed to award points to some members',
  'collectPoint.error.PARTIAL_DEDUCT_POINT_FAILED': 'Failed to deduct points from some members',
  'collectPoint.error.LOYALTY_CARD_SHOP_ERROR':
    'Store does not match the designated stores for this loyalty card',
  'collectPoint.error.ACCOUNT_SHOP_NOT_ELIGIBLE':
    'The store of the account does not match the designated stores for this loyalty card',
  'collectPoint.error.VALIDATE_SEND_POINTS_LIMIT_IN_DAYS_FAILED':
    'Exceeded the daily point awarding limit',
  'collectPoint.error.AMOUNT_TO_MPS_CARD_POINT_FAILED': 'Point awarding failed',
  'collectPoint.error.PARAMETERS_ERROR': 'Information error',
  'collectPoint.error.MEMBER_PHONE_NOT_FOUND': 'Phone number does not exist',
  'collectPoint.error.MEMBER_NOT_FULL': 'Not a full member',
  'collectPoint.error.INTERNAL_SERVER_ERROR': 'An error occurred, please try again later',
} as Record<string, string>;
